import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../actions/actions';

class Share extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { app, buttonSecondary } = this.props;

        return (
            <div>
                <header className="modal-header">
                    <h3>Copy & share</h3>
                </header>
                <div className="modal-body">
                    <p> Copy this link and share it with your client. </p>
                    <div className="input">
                        <div className="input__field">
                            <input type="text" disabled id="name" placeholder="Save as ..." defaultValue={app.shareUrl} />
                            <span className="clipboard"></span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    modal: state.modal,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Share.propTypes = {
    app: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
    buttonSecondary: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Share);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Share.jsx